export default __webpack_public_path__ + "static/media/TS02.1714192d.png";